import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";
import { message } from "antd";

export default class QuotationService extends Component {
  static async getQuotationCount(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_ADVANCE_URL}/template?code=quotation_count`)
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async getQuotationList(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_NEW_URL}/template?code=quotation_list`)
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.listingQuotationResponseFromWeb(resp.data);
    return response;
  }

  static async getLoanTermListing(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/maxCoverageTenure?dob=${payload.dob}&defermentPeriod=${payload.defermentPeriod}&sourceChannel=${payload.sourceChannel}`)
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.listingQuotationResponseFromWeb(resp.data);
    return response;
  }

  static async newQuotation(bankID, collectInformation) {

    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/new`);
    let resp = await axios.post(
      url,
      { sourceChannel: bankID, 
        collectInformation:collectInformation
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async updateQuotationDetails(payload, id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/update?quotationId=${id}`);
    let resp = await axios.post(
      url,
      {
        payload
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  /*  static async newProposal(payload) {
    let header = {};
    let resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL_BUSINESS}/mrtt/prubsn/api/v1/proposal/new`,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  } */

  static async newModule(module) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${module}/new`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getQuotation(id, category) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/attr?category=${category}&quotationId=${id}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async generateQuotation(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/generate?quotationId=${id}`);
    try {
      let resp = await axios.post(
        url,
        {},
        {
          headers: header,
        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      let response = {
        success: false,
        message: error.message
      }
      return response;
    }


  }

  static async generateQuotationDocument(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/template?code=uploaded_document_file`)
    console.log(url)
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async saveQuotation(id, category, payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/attr?category=${category}&quotationId=${id}`)

    try {
      let resp = await axios.post(
        url,
        payload,
        {
          headers: header,
        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      let response = {
        success: false,
        message: error.message
      }
      return response;
    }

  }

  // static async generateQuotation(id) {
  //   let header = await BaseWebService.normalHeaders();
  //   let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/generate?quotationId=${id}`);
  //   let resp = await axios.post(
  //     url,
  //     {},
  //     {
  //       headers: header,
  //     }
  //   );
  //   let response = BaseWebService.baseResponseFromWeb(resp.data);
  //   return response;
  // }

  static async generateQuotationData(payload) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_ADVANCE_URL}/template?code=quotation_detail_direct`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async calculateContributionAmount(id, payload) {
    let header = await BaseWebService.normalHeaders();
    try {
      let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/calculate?quotationId=${id}`);
      let resp = await axios.post(
        url,
        payload,
        {
          headers: header,
        }
      );
      let response = BaseWebService.standardResponseFromWeb(resp.data);
      return response;
    } catch (error) {
      console.log(error)
      return error;
    }

  }

  static async deleteQuotationById(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/delete?quotationId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }
  static async editGeneratedQuotation(id) {
    let header = await BaseWebService.normalHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/edit?quotationId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.standardResponseFromWeb(resp.data);
    return response;
  }

  static async checkDocumentIsUnderQuotation(quotationId) {
    let header = await BaseWebService.standardHeaders();
    let url = DOMPurify.sanitize(`${process.env.REACT_APP_FORM_URL}/quotation/documentsUnderQuotation?quotationId=${quotationId}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      },
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }
}
